import { ToCountBaseValueConverter } from 'General/Resources/ValueConverters/ToCountBase';
export class ToCountValueConverter extends ToCountBaseValueConverter {

}